<script>
import TemplateHeaderTableNew from '@/components/TemplateHeaderTableList'
import { downloadAction, getAction, getParams } from '@/command/netTool'

export default {
  name: 'data-report-group-meal',
  data() {
    return {
      records: [],
      current: 1,
      total: 0,
      pageSize: 10,
      params: { current: 1, size: 10 },
      selectedIds: [],
      loading: false
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList(params = this.params) {
      this.loading = true
      const requestParams = { ...params }
      getAction('/reportForm/getGroupMealPage', requestParams)
        .then(res => {
          const data = res.data || {}
          this.records = data.records || []
          this.current = data.current || 1
          this.total = data.total || 0
          this.pageSize = data.size || requestParams.size || 10
          this.params = {
            ...requestParams,
            current: this.current,
            size: this.pageSize
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getHeader() {
      return [
        {
          type: 'input',
          name: '团餐名称',
          key: 'productName',
          placeholder: '请输入名称',
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
          cols: 6,
          colsType: { xs: 24, sm: 24, md: 12, lg: 12, xl: 6, xxl: 6 }
        },
        {
          name: '日期选择',
          type: 'rangePicker',
          keys: ['dateGe', 'dateLe'],
          props: { allowClear: true },
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
          cols: 6,
          colsType: { xs: 24, sm: 24, md: 12, lg: 12, xl: 6, xxl: 6 }
        },
        {
          type: 'input',
          name: '商户名称',
          key: 'shopName',
          placeholder: '请输入名称',
          labelCol: { span: 8 },
          wrapperCol: { span: 16 },
          cols: 6,
          colsType: { xs: 24, sm: 24, md: 12, lg: 12, xl: 6, xxl: 6 }
        }
      ]
    },
    getColumns() {
      return [
        {
          title: '团餐名称',
          dataIndex: 'productName',
          align: 'center'
        },
        {
          title: '商户名',
          dataIndex: 'shopName',
          align: 'center'
        },
        {
          title: '订单数量',
          dataIndex: 'orderCount',
          align: 'center'
        },
        {
          title: '购买量',
          dataIndex: 'productQuantity',
          align: 'center'
        },
        {
          title: '订单金额（元）',
          dataIndex: 'totalAmount',
          align: 'center'
        },
        {
          title: '退款数量',
          dataIndex: 'refundCount',
          align: 'center'
        },
        {
          title: '退款金额（元）',
          dataIndex: 'refundAmount',
          align: 'center'
        },
        {
          title: '核销数量（次）',
          dataIndex: 'hxCount',
          align: 'center'
        },
        {
          title: '手续费（元）',
          dataIndex: 'feeAmount',
          align: 'center'
        },
        {
          title: '核销金额（元）',
          dataIndex: 'hxAmount',
          align: 'center'
        }
      ]
    },
    onChange(params) {
      this.selectedIds = []
      this.getList(params)
    },
    getRightButton() {
      return [
        {
          name: '导出Excel',
          type: 'normal2',
          onClick: () => {
            const params = { ...this.params }
            delete params.current
            delete params.size
            if (this.selectedIds.length) {
              params.ids = this.selectedIds.join(',')
            }
            downloadAction(
              `/api/reportForm/exportGroupMeal${getParams(params)}`,
              '团餐报表.xlsx'
            )
          }
        }
      ]
    },
    selectRow(data, records) {
      this.selectedIds = records.map(record => record.id)
    }
  },
  render() {
    return (
      <TemplateHeaderTableNew
        records={this.records}
        headerData={this.getHeader()}
        tableColumns={this.getColumns()}
        onChange={this.onChange}
        rightButton={this.getRightButton()}
        button={[]}
        filterRightButtonKey={['refresh', 'setting']}
        onSelectRow={this.selectRow}
        showAllHeader={true}
      />
    )
  }
}
</script>
